export const FIRST_PAGE = 0;
export const PAGE_PARAM = 'page';
export const SORT_BY_PARAM = 'sort_by';
export const SORT_ASC_PARAM = 'is_sort_asc';
export const RECORDS_PER_PAGE_PARAM = 'records_per_page';
